import { Injectable } from "@angular/core";
import { IdentityService } from "../authentication/identity.service";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { catchError, map, Observable, throwError } from "rxjs";
import { SearchTravelFareCommand, ISearchTravelFareCommandParameters } from "./command/search-travel-fare.command";
import { GetDestinationFrequentByPassCommand, IGetDestinationFrequentByPassParameters, IGetDestinationFrequentByPassResponse } from "./command/get-destination-frequent-by-pass.command";
import { TravelFareGridResponseDto, TravelFareResponseDto } from "../interfaces/apiInterfaces";
import { AlertService } from "app/services/components/alerts/alert.service";
import { SearchDefaultTravelFareCommand } from "./command/search-default-travel-fare.command";
import { GetTravelFareByCarrierCommand, IGetTravelFareByCarrierCommandParameters, IGridTravelFareResponse } from "./command/get-travel-fare-by-carrier.command";
import { ChatNotificationsService } from "../notifications/chat/notifications-chat.services";
import { ICommandResponse } from "../authentication/connection/iCommandResponse";
@Injectable()
export class TravelFareService {
  private titleMessage: string;

  constructor(
    private _identityService: IdentityService,
    private _connectionService: ConnectionServices,
    private _alertServirce: AlertService,
    private _notificationsService: ChatNotificationsService,
    // private _multiregionService: MultiRegionService,
    // private _localizationService: LocalizationService
  ) {
    this.titleMessage = 'carrier.configuration.fare.title';
  }

  //   public getGrid(
  //     page: number,
  //     size: number,
  //     column: string,
  //     sort: string
  //   ): Observable<IGridTravelFareResponse> {
  //     let command = new GridTravelFareCommand();
  //     command.setParameters(<IGridTravelFareCommandParameters>{
  //       sort: sort,
  //       size: size,
  //       page: page,
  //       column: column,
  //       carrierUserId: +this._identityService.userId
  //     });
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: TravelFareResponseDto) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }
  public getByName(name: string): Observable<TravelFareGridResponseDto[]> {
    // ESTOS nombres ya están definidos gracias a la nueva importación
    let command = new SearchTravelFareCommand();
    command.setParameters(<ISearchTravelFareCommandParameters>{
      carrierUserId: +this._identityService.userId,
      name: name
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: TravelFareResponseDto) => {
          console.log('Raw response from getByName:', response);
          if (Array.isArray(response)) {
            console.log('Response is array, returning as is');
            return response as any;
          }
          console.log('Response is object, returning content:', response.content);
          return response.content as any;
        }),
        catchError(error => {
          // Este servicio (_alertService) ahora está inyectado y funciona
          this._alertServirce.alertWarning(
            this.titleMessage,
            error
          );
          return throwError(() => false);
        })
      )
  }

  public getDefaultFare(): Observable<TravelFareGridResponseDto> {
    let command = new SearchDefaultTravelFareCommand();
    command.setParameters(<ISearchTravelFareCommandParameters>{
      carrierUserId: +this._identityService.userId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: TravelFareGridResponseDto) => {
          // response = this.transformFare(response, true);
          return response;
        }),
        catchError(error => {
          if (error.error.errorCode === 'DEFAULT_RATE_NOT_FOUND') {
            this._alertServirce.alertWarning(
              this.titleMessage,
              'toast.configuration.error_code.default_rate_not_found'
            );
          } else {
            this._alertServirce.alertWarning(
              this.titleMessage,
              error
            );
          }
          return throwError(() => false);
        })
      )

  }

  public getByCarrier(): Observable<TravelFareGridResponseDto[]> {
    let command = new GetTravelFareByCarrierCommand();
    command.setParameters(<IGetTravelFareByCarrierCommandParameters>{
      carrierUserId: +this._identityService.userId
    });
    return this._connectionService
      .Request(command)
      .pipe(map((response: any) => {
        console.log('Raw backend response:', response);
        // Backend returns array directly, not an object with content property
        if (Array.isArray(response)) {
          return response as TravelFareGridResponseDto[];
        }
        // Fallback in case structure changes
        return response.content ?? [];
      }),
        catchError(error => {
          if (error.error.errorCode === 'DEFAULT_RATE_NOT_FOUND') {
            this._notificationsService.showHttpErrorMessage(
              this.titleMessage,
              'toast.configuration.error_code.default_rate_not_found'
            );
          } else {
            this._notificationsService.showHttpErrorMessage(
              this.titleMessage,
              error
            );
          }
          return throwError(() => error);
        }));
  }

  //   public add(data: ICarrierRate): Observable<CarrierRateModel> {
  //     let command = new AddTravelFareCommand();
  //     command.setCarrierId(+this._identityService.userId);
  //     command.addCommandBody(data);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRateModel) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public addRule(
  //     carrierRateId: number,
  //     data: ICreateRuleCommandRequest
  //   ): Observable<CarrierRuleResponse> {
  //     let command = new CreateRuleCommand();
  //     command.setCarrierRateId(carrierRateId);
  //     command.addCommandBody(data);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRuleResponse) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public getDetail(
  //     carrierRateId: number
  //   ): Observable<IDetailTravelFareResponse> {
  //     let command = new DetailTravelFareCommand();
  //     command.setParameters(<IDetailTravelFareCommandParameters>{
  //       travelFareId: carrierRateId
  //     });
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: TravelFareDetailResponseDto) => {
  //         // response = this.transformFare(response, true) as TravelFareDetailResponseDto;
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public addDestination(
  //     data: IDestinationFormData
  //   ): Observable<ICreateDestinationFrequentResponse> {
  //     let command = new CreateDestinationFrequentCommand();
  //     command.setCarrierId(+this._identityService.userId);
  //     command.setCommandBody(data);
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: DestinationFrequentResponse) => {
  //         this._notificationsService.showSuccessMessage(
  //           'carrier.configuration.frequent_destinations',
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'carrier.configuration.frequent_destinations',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public removeDestination(
  //     destination: IDestinationFormData
  //   ): Observable<ICreateDestinationFrequentResponse> {
  //     let command = new RemoveDestinationFrequentCommand();
  //     command.setCarrierId(+this._identityService.userId);
  //     command.setCommandBody(destination);
  //     return this._connectionService
  //       .Request(command)
  //       .map(response => {
  //         this._notificationsService.showSuccessMessage(
  //           'carrier.configuration.frequent_destinations',
  //           'toast.configuration.message.frequent_destination_deleted'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.configuration.frequent_destinations',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public getDestination(
  //     page: number,
  //     size: number,
  //     column: string,
  //     sort: string,
  //     carrierRateId: number,
  //     find?: string
  //   ): Observable<IGetDestinationFrequentResponse> {
  //     let command = new GetDestinationFrequentCommand();
  //     command.setParameters(<IGetDestinationFrequentParameters>{
  //       sort: sort,
  //       size: size,
  //       page: page,
  //       column: column,
  //       carrierUserId: this._identityService.userId,
  //       carrierRateId: carrierRateId,
  //       find: find
  //     });
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: DestinationFrequentResponseDTO) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'carrier.configuration.frequent_destinations',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public addCancelTravel(
  //     data: ICancelTravelFormData
  //   ): Observable<ICreateCancelTravelResponse> {
  //     let command = new CreateCancelTravelCommand();
  //     command.setCarrierId(+this._identityService.userId);
  //     command.setCommandBody(data);
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: ICreateCancelTravelResponse) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           ''
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public updateRule(
  //     carrierRateId: number,
  //     data: IPutRuleCommandRequest,
  //     rateRuleId: number
  //   ): Observable<CarrierRuleResponse> {
  //     let command = new PutRuleCommand();
  //     command.setCarrierRateId(carrierRateId, rateRuleId);
  //     command.addCommandBody(data);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRuleResponse) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public updateFare(
  //     data: ICarrierRate,
  //     fareId: number
  //   ): Observable<CarrierRateModel> {
  //     let command = new PutTravelFareCommand();
  //     command.setCarrierId(+this._identityService.userId);
  //     // data = this.transformFare(data, false) as ICarrierRate;
  //     command.addCommandBody(data);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRateModel) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           'toast.shared.message.successful_message_modify'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public setTravelFareForContractor(
  //     contractorId: number,
  //     carrierRateId: number
  //   ): Observable<any> {
  //     let command = new SetTravelFareForContractorCommand();
  //     command.setParameters({
  //       carrierUserId: +this._identityService.userId,
  //       carrierRateId: carrierRateId,
  //       contractorId: contractorId
  //     });

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRateModel) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           'toast.shared.message.successful_message_modify'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   updateDestination(
  //     data: IDestinationFormData
  //   ): Observable<ICreateDestinationFrequentResponse> {
  //     let command = new UpdateDestinationFrequentCommand();
  //     command.setCarrierId(+this._identityService.userId);
  //     command.setCommandBody(data);
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: DestinationFrequentResponse) => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.configuration.frequent_destinations',
  //           'toast.shared.message.successful_message_modify'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.configuration.frequent_destinations',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   createDefaultBaseRate(): Observable<CarrierRateModel> {
  //     let command = new AddBaseDefaultFareCommand();
  //     command.setCarrierId(+this._identityService.userId);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRateModel) => {
  //         this._notificationsService.showSuccessMessage(
  //           this.titleMessage,
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   simulateRate(data: IRateSimulationRequest, travelFareId: number): Observable<IRateSimulationResponse> {
  //     let command = new SimulatePriceWithFareCommand();
  //     command.setParameters(
  //       {
  //         carrierId: +this._identityService.userId,
  //         travelFareId: travelFareId,
  //         kilometers: data.kilometers,
  //         transportType: data.transportType,
  //         duration: data.duration,
  //         origin: data.origin,
  //         destination: data.destination
  //       }
  //     );

  //     return this._connectionService
  //       .Request(command)
  //       .map((response: CarrierRateModel) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         console.log('simulateRate error');
  //         console.log(error);
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   private transformFare(response: TravelFareDetailResponseDto | ICarrierRate, onReceive: boolean) {
  //     if (this._localizationService.localeData.measureUnits === MeasureUnitsEnum.IMPERIAL) {
  //       const fieldsKms = [
  //         'priceSegmentFrom',
  //         'priceSegmentTo',
  //         'priceSegmentPreviousTo',
  //         'kmsIncluded',
  //         'kmsIncludedPerHour',
  //         'minDistance',
  //         'minCost'
  //       ];
  //       const fieldFeet = [];
  //       response['pricePerKm'] = response['pricePerKm'] * (onReceive ? 1.60934 : (1 / 1.60934))
  //       response['pricePerKm'] = (response['pricePerKm'] * 100) / 100
  //       let rules: Array<any> = response['carrierRateRules'] || response ['rulesCollection'];
  //       if (!rules) {
  //         return response;
  //       }
  //       rules.forEach((value, index, array) => {
  //         let obj = JSON.parse(value.parameter);
  //         fieldsKms.forEach(field => {
  //           if (obj[field]) {
  //             obj[field] = obj[field] * (onReceive ? (1 / 1.60934) : 1.60934)
  //             if (onReceive) {
  //               obj[field] = (obj[field] * 10) / 10
  //             } else {
  //               obj[field] = (obj[field] * 10) / 10
  //             }
  //           }
  //         });
  //         array[index].parameter = JSON.stringify(obj);
  //       });
  //       return response;
  //     } else {
  //       return response;
  //     }
  //   }

  //   public addWithDestinations(data: ICarrierRate, rateToCopy: number) {
  //     let command = new AddTravelFareWihtDestinationsCommand();
  //     command.setCarrierId(+this._identityService.userId, rateToCopy);
  //     command.addCommandBody(data);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public addByService(data: ICarrierRateByService, rateToCopy: number) {
  //     let command = new AddTravelFareByServiceCommand();
  //     command.setCarrierId(+this._identityService.userId, rateToCopy);
  //     command.addCommandBody(data);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public deleteRateWithDestinations(rateId: number) {
  //     let command = new DeleteTravelFareWihtDestinationsCommand();
  //     command.setCarrierRateId(rateId);

  //     return this._connectionService
  //       .Request(command)
  //       .map((response) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  public getDestinationByPass(
    passId: number
  ): Observable<IGetDestinationFrequentByPassResponse[]> {
    let command = new GetDestinationFrequentByPassCommand();
    command.setParameters(<IGetDestinationFrequentByPassParameters>{
      carrierUserId: this._identityService.userId,
      passId: passId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response as any;
        }),
        catchError((error) => {
          // this._notificationsService.showHttpErrorMessage(
          //       'carrier.configuration.frequent_destinations',
          //       error
          //     );
          return throwError(() => false);
        }));
    // return this._connectionService
    //   .Request(command)
    //   .map((response: DestinationFrequentResponse[]) => {
    //     return response;
    //   })
    //   .catch(error => {
    //     this._notificationsService.showHttpErrorMessage(
    //       'carrier.configuration.frequent_destinations',
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

  //   getFamilyRates(rateId:number) {
  //     let command = new GetFamilyRatesCommand();
  //     command.setParameters({
  //       travelFareId: rateId
  //     })
  //     return this._connectionService.Request(command).map((response:TransportRateListDto) => response)
  //       .catch((error) => Observable.throw(false));
  //   }

  //   deleteRateFamily(rateId:number) {
  //     let command = new DeleteFamilyRateCommand();
  //     command.setParameters({
  //       rateId: rateId.toString(),
  //       subUserId: this._identityService.subUserId
  //     });

  //     return this._connectionService.Request(command).map((response) => response)
  //       .catch((error) => Observable.throw(false));
  //   }

}
